<template>
  <div class="cyma-c-layout">
    <cyma-sidebar />
    <main class="cyma-c-main">
      <slot />
    </main>
  </div>
</template>

<script>
import CymaSidebar from '../components/site/CymaSidebar'

export default {
  name: 'CymaLayout',
  components: { CymaSidebar }
}
</script>
